"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Header;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const store_1 = require("../../store");
const document_1 = require("../../slices/document");
const conversation_1 = require("../../slices/conversation");
const ChatThreadsHeaderButton_1 = __importDefault(require("../Conversations/ChatThreadsHeaderButton"));
const CloseButton_1 = __importDefault(require("../AppButton/CloseButton"));
const AppText_1 = require("../AppText");
const colors_1 = require("../../common/colors");
const spacing_1 = require("../../common/spacing");
const borders_1 = require("../../common/borders");
const ImageModelsButton_1 = __importDefault(require("../AppCharacter/ImageModelsButton"));
const AppTooltip_1 = __importDefault(require("../AppTooltip"));
const character_1 = require("../../services/character");
const user_1 = require("../../store/selectors/user");
const useRequest_1 = __importDefault(require("../../hooks/useRequest"));
const user_2 = require("../../slices/user");
function Header() {
    const dispatch = (0, store_1.useAppDispatch)();
    const { request } = (0, useRequest_1.default)();
    const isAutoPlay = (0, react_redux_1.useSelector)(conversation_1.selectAutoPlay);
    const [hoveredAutoPlay, setHoveredAutoPlay] = (0, react_1.useState)(false);
    const documentCharacter = (0, react_redux_1.useSelector)(user_1.selectCharacterProfile);
    const handleAutoPlayPress = (0, react_1.useCallback)(() => {
        dispatch((0, conversation_1.toogleAutoPlay)());
    }, [dispatch]);
    const handleChangeStyleSelection = (0, react_1.useCallback)((finalSelection) => {
        if (documentCharacter) {
            request(character_1.createEditCharacter, {
                id: documentCharacter.id,
                characterName: documentCharacter.characterName,
                background: documentCharacter.background,
                styleString: finalSelection.imageModel?.styleString,
                imageModelId: finalSelection.modelId,
                aspectRatio: finalSelection.aspectRatio,
            }, true).then((characterResponse) => {
                if (characterResponse) {
                    dispatch((0, user_2.setCharacter)(characterResponse.data));
                }
            });
        }
    }, [documentCharacter, request, dispatch]);
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.container, children: [(0, jsx_runtime_1.jsx)(CloseButton_1.default, { verticalOffset: 10, onClose: () => dispatch((0, document_1.toggleDocumentConversationOpen)()) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.colorContainer, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.text, children: "Chat" }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', gap: 12 }, children: [(0, jsx_runtime_1.jsx)(ChatThreadsHeaderButton_1.default, { menuVerticalOffset: 12, menuHorizontalOffset: 116 }), (0, jsx_runtime_1.jsx)(ImageModelsButton_1.default, { viewType: "icon", onChangeStyle: handleChangeStyleSelection, showModelSelect: false, selectedStyle: documentCharacter.styleString ?? undefined, selectedRatio: documentCharacter.aspectRatio }), (0, jsx_runtime_1.jsx)(AppTooltip_1.default, { label: "Auto Read Responses", children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: handleAutoPlayPress, onHoverIn: () => setHoveredAutoPlay(true), onHoverOut: () => setHoveredAutoPlay(false), style: styles.autoPlayButton, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: isAutoPlay ? pro_solid_svg_icons_1.faPlayCircle : pro_light_svg_icons_1.faPlayCircle, color: isAutoPlay ? colors_1.Colors.PRIMARY_BLUE : colors_1.Colors.white, size: 20, style: { opacity: hoveredAutoPlay ? 0.7 : 1 } }) }) })] })] })] }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        backgroundColor: colors_1.Colors.DARK_600,
        overflow: 'hidden',
        borderTopLeftRadius: borders_1.Borders.RADIUS_2XL,
        borderTopRightRadius: borders_1.Borders.RADIUS_2XL,
    },
    text: {
        color: colors_1.Colors.white,
        fontSize: 20,
        fontWeight: '500',
        lineHeight: 28,
        flex: 1,
    },
    colorContainer: {
        backgroundColor: `${colors_1.Colors.white}10`,
        flexDirection: 'row',
        paddingVertical: spacing_1.Spacing.SPACING_LG,
        paddingLeft: spacing_1.Spacing.SPACING_3XL,
        paddingRight: spacing_1.Spacing.SPACING_XL,
    },
    autoPlayButton: {
        marginRight: 24 + 32 + 8 - 16,
        justifyContent: 'center',
    },
    styleChangeButton: {
        marginLeft: 16,
        justifyContent: 'center',
    },
    buttonHover: {
        backgroundColor: colors_1.Colors.DARK_500,
    },
});
